import { useEffect, useState } from 'react';

export function useDetectUserTouch() {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.PointerEvent && 'maxTouchPoints' in navigator) {
      // if Pointer Events are supported, just check maxTouchPoints
      if (navigator.maxTouchPoints > 0) {
        setIsTouch(true);
      }
    } else {
      // no Pointer Events...
      if (
        window.matchMedia &&
        window.matchMedia('(any-pointer:coarse)').matches
      ) {
        // check for any-pointer:coarse which mostly means touchscreen
        setIsTouch(true);
      } else if (window.TouchEvent || 'ontouchstart' in window) {
        // last resort - check for exposed touch events API / event handler
        setIsTouch(true);
      }
    }
  }, []);
  return isTouch;
}
